export type InviteLocale = "zh-CN" | "en";

export type ShareCardModel = {
  brand: string;
  slogan: string;
  invitation: string;
  inviteLabel: string;
  inviteCode: string;
  shareUrl: string;
  shareTitle: string;
  shareText: string;
  filename: string;
};

const INVITE_CODE_PATTERN = /^[A-HJ-NP-Z2-9]{8}$/;

export function normalizeInviteCode(value: unknown): string | null {
  const candidate = typeof value === "string" ? value.trim().toUpperCase() : "";
  return INVITE_CODE_PATTERN.test(candidate) ? candidate : null;
}

export function buildInviteShareUrl(code: string, locale: InviteLocale): string {
  const normalized = normalizeInviteCode(code);
  if (!normalized) throw new Error("邀请码无效");
  const url = new URL("https://neckmoves.com/");
  url.searchParams.set("invite", normalized);
  if (locale === "en") url.searchParams.set("locale", "en");
  return url.toString();
}

export function buildShareCardModel(name: string, code: string, locale: InviteLocale): ShareCardModel {
  const inviteCode = normalizeInviteCode(code);
  if (!inviteCode) throw new Error("邀请码无效");
  const displayName = name.trim();
  const english = locale === "en";
  const slogan = english ? "A gentle one-minute movement break" : "用一分钟，轻轻活动一下脖子";
  return {
    brand: "NeckMoves",
    slogan,
    invitation: displayName
      ? (english ? `${displayName} invited you to move` : `${displayName}邀请你一起动一动`)
      : (english ? "You're invited to move with us" : "邀请你一起动一动"),
    inviteLabel: english ? "INVITE CODE" : "邀请码",
    inviteCode,
    shareUrl: buildInviteShareUrl(inviteCode, locale),
    shareTitle: english ? "Move with me on NeckMoves" : "一起用 NeckMoves 动一动",
    shareText: `${displayName
      ? (english ? `${displayName} invited you to try NeckMoves: a gentle one-minute movement break.` : `${displayName}邀请你体验 NeckMoves：${slogan}。`)
      : (english ? "Try NeckMoves: a gentle one-minute movement break." : `来体验 NeckMoves：${slogan}。`)} ${buildInviteShareUrl(inviteCode, locale)}`,
    filename: `neckmoves-invite-${inviteCode}.png`,
  };
}
